import React, { Component } from 'react'
import { get } from 'lodash'
import imgLines from 'static/images/patterns/lines.png'
import Page from 'components/Page'
import FullWidthSection from 'components/FullWidthSection'
import { Row, Col, Container } from 'components/Layout'
import BlogAuthor from 'features/Blog/BlogAuthor'
import BlogPreview from 'features/Blog/BlogPreview'
import Markdown from 'features/Markdown'
import Footer from 'components/Footer'
import Button from 'components/Button'
import cn from 'classnames'
import s from './BlogArticle.scss'
import colors from 'styles/colors-export.css'
import sText from 'components/Text/Text.scss'
import sAnim from 'components/Animation/Animation.scss'
import sLay from 'styles/modules/layout.scss'

export default class BlogArticle extends Component {
  componentWillMount() {
    const { getArticles } = this.props
    getArticles()
  }
  render() {
    const { article, articles, location } = this.props
    const articleFields = article && article.fields
    const articlesIndex = articles.findIndex(item => articleFields.slug === item.fields.slug) || 1
    const nextArticle = articles[articlesIndex + 1] || articles[articlesIndex - 1]
    const defaultTitle = 'Blog'

    const getInnerContent = () => {
      const bannerImage =
        get(articleFields, 'bannerImage.fields.file.url') ||
        get(articleFields, 'featuredImage.fields.file.url') ||
        imgLines

      if (articleFields && articleFields.body) {
        return (
          <div>
            <FullWidthSection
              className={s.header}
              style={{
                color: 'white',
                backgroundColor: colors.primary,
                backgroundImage: `url(${bannerImage})`,
              }}
            >
              <h1 className={sText.heading1}>{articleFields.title}</h1>
            </FullWidthSection>
            <Container className={cn(s.content, sAnim.comeUp, 'lg')}>
              <Row
                className={cn(
                  'md',
                  sLay['layout-xs-column'],
                  sLay['layout-sm-column'],
                  sLay['layout-gt-sm-row']
                )}
              >
                <Col className={cn('md', sLay.flex)}>
                  <div style={{ marginBottom: '30px' }}>
                    <Button to="/blog" prev>
                      Back to blog
                    </Button>
                  </div>
                </Col>
                <Col className={cn('md', s.contentCol)}>
                  <Markdown text={articleFields.body} openLinksInNewTabs />
                </Col>
                <Col
                  className={cn(
                    'md',
                    sLay.flex,
                    sLay['layout-column'],
                    sLay['layout-align-start-start']
                  )}
                >
                  <BlogAuthor vertical article={article} location={location} />
                </Col>
              </Row>
              <div className={sLay['layout-column']} style={{ paddingTop: '60px' }}>
                <BlogPreview horizontal article={nextArticle} location={location} />
              </div>
            </Container>
          </div>
        )
      }
      return (
        <div>
          <FullWidthSection style={{ color: 'white', background: colors.primary }}>
            <h1 className={sText.heading1}>&nbsp;</h1>
          </FullWidthSection>
        </div>
      )
    }
    return (
      <Page
        layout={{ header: 'landing' }}
        title={get(articleFields, 'title', defaultTitle)}
        socialTitle={get(articleFields, 'title', defaultTitle)}
        image={get(articleFields, 'featuredImage.fields.file.url')}
        twitterImage={get(articleFields, 'featuredImage.fields.file.url')}
        description={get(articleFields, 'blurb', '').replace(/<(?:.|\n)*?>/gm, '')}
        socialDescription={get(articleFields, 'blurb', '').replace(/<(?:.|\n)*?>/gm, '')}
      >
        {getInnerContent()}
        <Footer white />
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogArticle/BlogArticle.jsx